import React, { useEffect, useState } from "react";

// @ts-ignore
import football from "../../assets/football.png";
// @ts-ignore
import slotmachine from "../../assets/slot_machine.png";
// @ts-ignore
import footer from "../../assets/footer.webp";
import ExclusiveDealsCard from "../../components/ExclusiveDealsCard";
import GameCarousel from "../../components/GameCarousel";
import OptionsCard from "../../components/OptionsCard";
import { ExclusiveDealsAPI } from "../../api/exclusiveDeals";
import { getCommaSeparatedString } from "../../constants/Helper";
import { ExclusiveDealsColorScheme } from "../../constants/constants";
import { CasinoAPI } from "../../api/casino";
import { GamesAPI } from "../../api/games";
import { SettingsAPI } from "../../api/settings";
import CompactCasinoCard from "../../components/CompactCasinoCard";
import { CasinoResponse, SettingsResponse } from "../../constants/responses";
import PreLoader from "../../components/PreLoader";
import NAVBAR from "../../components/Navbar";
import { useTranslation } from "react-i18next";
import { useIpDetails } from "../../services/ip_provider";

export default function Homepage() {
  const { t } = useTranslation();
  const { ipData, loading: ipLoading, error } = useIpDetails();
  const [exclusiveDeals, setExclusiveDeals] = useState<any[]>();
  const [settings, setSettings] = useState<SettingsResponse>();
  const [onlineCasinos, setOnlineCasinos] = useState<CasinoResponse[]>();
  const [games, setGames] = useState<any[]>();
  const [countryFlag, setCountryFlag] = useState<string | null>(null);
  const [country, setCountry] = useState<string | null>(null);

  async function fetchSettings() {
    try {
      const res = await SettingsAPI.getData();
      if (res.data.id) {
        setSettings(res.data);
      }
    } catch (error) {
      console.log("Something went wrong. Try Again!");
    }
  }
  async function fetchExclusiveDeals() {
    try {
      const res = await ExclusiveDealsAPI.getActive();
      if (res.data) {
        setExclusiveDeals(res.data);
      }
    } catch (error) {
      console.log("Something went wrong. Try Again!");
    }
  }
  async function fetchGames() {
    try {
      const res = await GamesAPI.getActive();
      if (res.data) {
        setGames(res.data);
        const data = res.data;
        const newArray = data.map(
          (item: { picture: any; contentName: any; externalLink: any }) => ({
            image: item.picture,
            name: item.contentName,
            externalLink: item.externalLink,
          })
        );

        setGames(newArray);
      }
    } catch (error) {
      console.log("Something went wrong. Try Again!");
    }
  }
  async function fetchCasinos() {
    try {
      const res = await CasinoAPI.getActive();
      if (res.data) {
        const casinos = res.data;
        const sortedCasinos = Array.isArray(casinos)
          ? casinos.sort(
              (a, b) => parseInt(a.homeSequence) - parseInt(b.homeSequence)
            )
          : [];
        setOnlineCasinos(sortedCasinos);
      }
    } catch (error) {
      console.log("Something went wrong. Try Again!");
    }
  }

  useEffect(() => {
    if (ipData) {
      setCountry(ipData.country_name);
      setCountryFlag(ipData.location.country_flag);

      fetchSettings();
      fetchExclusiveDeals();
      fetchCasinos();
      fetchGames();
    }
  }, [ipData]);

  if (
    ipLoading ||
    !ipData ||
    !settings ||
    !exclusiveDeals ||
    !onlineCasinos ||
    !games
  ) {
    return (
      <div className="h-screen w-full bg-white flex justify-center items-center">
        <PreLoader />
      </div>
    );
  }

  return (
    <div className="p-0 m-0 flex flex-col min-h-full w-full items-center text-white">
      <NAVBAR />

      {/* Banner */}
      {settings.show && settings?.picture && (
        <section className="relative w-full h-[10rem] lg:h-[23rem] 3xl:h-[27rem] mb-3 flex justify-end items-end ">
          <img
            src={settings?.picture}
            alt="Deal der Woche"
            className="absolute w-full h-full object-fit "
          />
          {settings.refLink && (
            <div
              onClick={() => window.open(settings?.refLink, "_blank")}
              className="z-10 text-[0.9rem] lg:text-[1.5rem] py-[0.8rem] px-[1.3rem] lg:px-[3rem] mx-6 mb-4 
              text-center rounded-full backdrop-blur-md bg-black-900/60 border-[1.5px] border-warning
              text-white font-semibold cursor-pointer select-none animate-radiateYellow"
            >
              {t("receive_bonus")}
            </div>
          )}
        </section>
      )}

      {/* Exclusive Deals */}

      {exclusiveDeals && exclusiveDeals?.length >= 1 && (
        <>
          <h1 className="text-[1.6rem] lg:text-[2.5rem] font-defaultFont text-center mt-[3rem]">
            {t("exclusive_deals_heading")}
          </h1>
          <section className="mt-5 md:w-[75%] justify-center items-center grid grid-cols-2 lg:grid-cols-4 gap-2 md:gap-4 p-2">
            {exclusiveDeals.map((deal, index) => (
              <div
                key={index}
                className="flex w-full justify-center items-center"
              >
                <ExclusiveDealsCard
                  index={index}
                  flag={countryFlag}
                  logo={deal.picture}
                  bonusPercentage={deal.bonusPercentage}
                  upto={deal.bonusUpto}
                  allowedCountries={getCommaSeparatedString(
                    deal.allowedCountries
                  )}
                  country={country?.toLowerCase() ?? ""}
                  refURL={deal.refURL}
                  fromColor={
                    ExclusiveDealsColorScheme[
                      index % ExclusiveDealsColorScheme.length
                    ].fromColor
                  }
                  toColor={
                    ExclusiveDealsColorScheme[
                      index % ExclusiveDealsColorScheme.length
                    ].toColor
                  }
                />
              </div>
            ))}
          </section>
        </>
      )}

      {/* Best Casinos */}
      {onlineCasinos && onlineCasinos?.length >= 1 && (
        <section className="w-full lg:w-[75%] flex flex-col justify-center items-center">
          <h2 className="my-[5rem] text-[1.6rem] lg:text-[2.5rem] font-defaultFont text-center">
            {t("best_casions")}
          </h2>
          <div className="w-[90%] lg:w-full ">
            {onlineCasinos.slice(0, 5).map((casino, index) => (
              <div
                key={index}
                className="flex w-full justify-center items-center"
              >
                <CompactCasinoCard
                  id={casino.id}
                  flag={countryFlag ?? ""}
                  country={country ?? ""}
                  allowedCountries={
                    casino.allowedCountries
                      ? getCommaSeparatedString(casino.allowedCountries)
                      : ""
                  }
                  index={index}
                  logo={casino.picture}
                  welcomeBonusText={casino.welcomeBonusText}
                  freeBonusText={casino.freeBonusText}
                  refURL={casino.refURL}
                />
              </div>
            ))}
            <a href="casinos">
              <div
                className={`text-center text-white py-4 cursor-pointer select-none ${
                  onlineCasinos.length >= 5
                    ? "bg-[#2a2a2a]"
                    : onlineCasinos.length % 2 === 0
                    ? "bg-[#3a3a3a]"
                    : "bg-[#2a2a2a]"
                }`}
              >
                {t("show_more_providers")}
              </div>
            </a>
          </div>
        </section>
      )}

      {/* Best Games */}
      {games && (
        <section className="mt-[2.5rem] w-full lg:w-[75%] flex flex-col justify-center items-center">
          <section className="flex flex-col w-[90%] lg:w-[50%] my-2 text-justify text-lg ">
            <text>{t("paragraph1")}</text>
          </section>
          <h3 className="mt-[2.5rem] mb-3 text-[1.6rem] lg:text-[2.5rem] font-defaultFont text-center">
            {t("best_games")}
          </h3>

          <GameCarousel games={games} />
        </section>
      )}

      {/* Best Providers */}
      <section className="my-[5rem] w-full lg:w-[75%] grid grid-cols-1 md:grid-cols-2 gap-4 p-4">
        <OptionsCard
          img={football}
          alt="Sportwetten"
          title={t("sportsbetting")}
          subTitle={t("among_the_best_providers")}
          style={{ backgroundColor: "#007000" }}
          link="sports-betting"
        />
        <OptionsCard
          img={slotmachine}
          alt="Online Casino"
          title={t("online_casino")}
          subTitle={t("among_the_best_providers")}
          style={{ backgroundColor: "#cdbf00" }}
          link="casinos"
        />
      </section>

      {/* Contact Section */}
      <section
        className="w-full min-h-[90vh] bg-cover bg-center grid md:grid-cols-2"
        style={{ backgroundImage: `url(${footer})` }}
      >
        <div className="hidden md:flex" />
        <div className="flex flex-col items-center justify-center text-center px-[4rem] py-[2rem]">
          <h2 className="text-[2rem] md:text-[1.5rem] lg:text-[2rem] mb-[5rem] font-bold">
            {t("weekly_competition")}
          </h2>
          <h2 className="text-[1.6rem] mb-[2rem] font-bold">
            {t("register_now_and_win")}
          </h2>
          <h2 className="text-[1.6rem] font-semibold">
            {t("register_description")}
          </h2>

          <div className="text-[1.3rem] py-[1rem] w-[85%] lg:w-[50%] rounded-full bg-white text-[#3a3a3a] mt-5 cursor-pointer select-none">
            {t("email_address")}
          </div>
          <div className="text-[1.3rem] py-[1rem] w-[85%] lg:w-[50%] rounded-full bg-[#007000] text-white my-3 cursor-pointer select-none animate-radiate">
            {t("register")}
          </div>
        </div>
      </section>
    </div>
  );
}
